<template>
  <div class="bk-container">
    <Bk :list="HY" tab="0" title="行业板块" />
    <div class="interval"></div>
    <Bk :list="GN" tab="1" title="概念板块" />
    <div class="interval"></div>
    <Bk :list="DY" tab="2" title="地区板块" />
  </div>
</template>

<script type="text/ecmascript-6">
import {request} from '@/api/request'
import Bk from './bk.vue'
export default {
  components: {
    Bk
  },
  data () {
    return {
      DY: {down: [], up: []},
      GN: {down: [], up: []},
      HY: {down: [], up: []},
    }
  },
  created() {
    this.getBKdata()
  },
  methods: {
    goToRank() {
      this.$router.push(
        {
          path: `/bkRank.html`,
        }
      )
    },
    async getBKdata() {
      const res = await request.get({
        url: request.apis.quote.bkUpDownPlate,
        params: {}
      })
      if (res) {
        res['XBHS.DY'] && (this.DY = res['XBHS.DY'])
        res['XBHS.GN'] && (this.GN = res['XBHS.GN'])
        res['XBHS.HY'] && (this.HY = res['XBHS.HY'])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.interval
  height .06rem
  background #F5F5F5
</style>